import './InventorySection.scss';

type InventorySectionProps = {
  title?: string;
  renderContent: () => React.ReactNode;
};

export const InventorySection = ({
  title,
  renderContent,
}: InventorySectionProps) => {
  return (
    <div className="inventory-section">
      {title && <div className="inventory-section-title">{title}</div>}
      <div className="inventory-section-content">{renderContent()}</div>
    </div>
  );
};
